import { useCheckUserRole } from '@/components/HOC/UserRoleGuard';
import { Navigate, createFileRoute } from '@tanstack/react-router';

function CompetenceIndexRoute() {
	const isAdmin = useCheckUserRole('ADMIN');
	// Admins land on the compliance matrix (their primary tool); everyone else
	// goes to their own competence profile, the only sub-route they can act on.
	return <Navigate to={isAdmin ? '/competence/matrix' : '/competence/me'} replace />;
}

export const Route = createFileRoute('/_authenticated/_app/competence/')({
	component: CompetenceIndexRoute,
});
